import React from "react";
import { Box, CircularProgress } from "@mui/material";

type DialogLoadingOverlayProps = {
  loading?: boolean;
};

export const DialogLoadingOverlay: React.FC<DialogLoadingOverlayProps> = ({ loading = false }) => {
  if (!loading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "rgba(255,255,255,0.65)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1,
      }}
    >
      <CircularProgress sx={{ color: "#707070" }} />
    </Box>
  );
};

export const TableLoadingSpinner: React.FC = () => (
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4 }}>
    <CircularProgress sx={{ color: "#707070" }} />
  </Box>
);
